import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

// En dessous de cette largeur on bascule sur l'UI mobile (breakpoint md de Bootstrap).
const MOBILE_QUERY = "(max-width: 768px)";

const isMobileUserAgent = () =>
  /Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry|Opera Mini|IEMobile/i.test(
    navigator.userAgent || ""
  );

// Vrai quand l'appareil peut PRENDRE une photo depuis un champ fichier
// (`capture` sur <input type="file">) : l'app native (Capacitor ouvre alors
// l'appareil photo) et les navigateurs mobiles. Sur un poste de bureau,
// l'attribut est ignoré et ouvrirait un sélecteur de fichiers déroutant.
export const canCapturePhoto = () =>
  Capacitor.isNativePlatform() || isMobileUserAgent();

const computeIsMobile = () =>
  Capacitor.isNativePlatform() ||
  window.matchMedia(MOBILE_QUERY).matches ||
  isMobileUserAgent();

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(computeIsMobile);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = () => setIsMobile(computeIsMobile());
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
